import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
} from "@mui/material";
import { formatToBRL } from "../../Utils/utils";
import Pedido from "../Shared/Interfaces/Pedido";
import DefaultLoader from "../Shared/DefaultLoader";

interface PedidoModalProps {
  open: boolean;
  onClose: () => void;
  onConcluir: (valorTotal: number, observacao: string) => void;
  pedido: Pedido;
  loading: boolean;
}

const OrcamentoModalResumo: React.FC<PedidoModalProps> = ({
  open,
  onClose,
  onConcluir,
  pedido,
  loading,
}) => {
  const [totalGeral, setTotalGeral] = useState(0);
  const [observacao, setObservacao] = useState("");

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: { xs: "95vw", sm: 800 },
    height: "auto",
    transform: "translate(-50%, -50%)",
    maxWidth: "90vw",
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 2, sm: 4 },
  };

  const carregaAuxiliares = () => {
    setTotalGeral(pedido.valorTotal);
    setObservacao(pedido.observacoes);
  };

  useEffect(() => {
    if (open) {
      setTotalGeral(0);
      setObservacao("");
      carregaAuxiliares();
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2">
          Resumo do Orçamento
        </Typography>
        <Typography sx={{ mt: 2 }}>
          <b>Cliente:</b> {pedido.cliente.nome}
        </Typography>
        <Typography sx={{ mt: 2 }}>
          <b>Produtos:</b>
        </Typography>
        <ul>
          {pedido.itensPedido.map((item) => (
            <li key={item.idProduto}>
              {item.descricao} - Qtd: {item.quantidade} - Preço:
              {formatToBRL(item.preco)} - Total: {formatToBRL(item.valorTotal)}
            </li>
          ))}
        </ul>

        {/* Campo de observações */}
        <TextField
          label="Observações"
          fullWidth
          multiline
          minRows={3}
          sx={{ mt: 3 }}
          value={observacao}
          onChange={(e) => setObservacao(e.target.value)}
        />

        <Typography sx={{ mt: 2, mb: 2 }}>
          <b>Total Orçamento:</b> {formatToBRL(totalGeral)}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button variant="contained" onClick={onClose}>
            Fechar
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            onClick={() => onConcluir(totalGeral, observacao)}
          >
            {loading ? (
              <DefaultLoader
                height="3em"
                width="3em"
                colors={["#1876D2", "#1876D2", "#1876D2", "#1876D2", "#1876D2"]}
                textInfo="Gerando Orçamento"
              />
            ) : (
              "Concluir"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OrcamentoModalResumo;
